export function formatTitle(title: string) {
  return title.length > 35 ? `${title.slice(0, 35)}...` : title
}
